// COREX-1769 introduced a new "Terms Acceptance" footer on the Plans page,
// which is gated behind a feature flag to allow promoId targeting. This is an
// experiment which may evolve into a config option in future.
export const PROVIDER_APP_PLANS_PAGE_TERMS_ACCEPTANCE_FOOTER = {
  NAME: 'provider_app_plans_page_terms_acceptance_footer_enabled',
} as const;

// LUM-336 + LUM-347: A/B test toggling the Lumis chat / organic-chat
// funnel. String-variant flag (see GrowthBook:
// https://growthbook.prod.updatron.tools/features/lumis_chat_experiment).
//
//   - 'control' (default) — show the existing /choice gate.
//   - 'organic_chat'      — skip /choice, push qualified users straight into
//                           the /offer-wizard funnel and render the
//                           one-shot results step on submit.
//   - 'hybrid_chat'       — same /offer-wizard funnel as organic_chat, but
//                           the inline AI Suggestion card is replaced by
//                           a persistent "Ask AI" FAB that opens a chat
//                           drawer seeded with partial [QUIZ CONTEXT].
//
// The flag MUST resolve to one of these strings for the redirect to fire;
// an unset flag or any unknown value falls through to control by virtue
// of the strict equality check at the call sites.
export const LUMIS_CHAT_EXPERIMENT = {
  NAME: 'lumis_chat_experiment',
  VARIANTS: {
    CONTROL: 'control',
    ORGANIC_CHAT: 'organic_chat',
    HYBRID_CHAT: 'hybrid_chat',
  },
} as const;

// COREX-2176: RealPage's embed always sends `skipToPlans`, which skips the
// quiz. When this flag is on, /qualify ignores that skip and shows the quiz,
// for the RealPage quiz A/B test (DATA-735). Scoped to RealPage by a promoId
// targeting rule in GrowthBook, not in code:
// https://growthbook.prod.updatron.tools/features/provider-app-force-quiz
export const PROVIDER_APP_FORCE_QUIZ = {
  NAME: 'provider-app-force-quiz',
} as const;

// COREX-2178: shows the call center CTA at the top of the results page, for
// embeds like RealPage's that hide the site header (and its phone number).
// Scoped to RealPage by a promoId targeting rule in GrowthBook, not in code:
// https://growthbook.prod.updatron.tools/features/provider-app-show-tfn-in-header
export const PROVIDER_APP_SHOW_TFN_IN_HEADER = {
  NAME: 'provider-app-show-tfn-in-header',
} as const;
